<div *ngFor="let notification of notifications$ | async; trackByFields: 'id'" class="notification" [ngClass]="notification.type | lowercase" [autoDismiss]="notification">
	<icon class="notification-icon" *ngIf="notification.icon" [type]="notification.icon"></icon>
	<p class="text-16">
		{{ notification.message }}
		<span class="timestamp text-14" *ngIf="showTime">{{ getFromNow(notification.timestamp) }}</span>
	</p>
	<button class="close" *ngIf="(showClose === 'auto' && !notification.duration) || showClose === 'true'" (click)="dismiss(notification.id)">
		<icon type="times"></icon>
	</button>
	<ng-container *ngIf="notification.routingConfig">
		<div class="line-break"></div>
		<a
			[routerLink]="notification.routingConfig.routerLink"
			[queryParams]="notification.routingConfig.queryParams"
			[queryParamsHandling]="notification.routingConfig.queryParamsHandling"
			class="text-16-bold underline"
		>
			<span [dcrHTMLKey]="notification.routingConfig.routingDcrKey">{{ notification.routingConfig.routingDcrValue }}</span>
		</a>
	</ng-container>
	<ng-container *ngIf="notification.actionConfig">
		<div class="line-break"></div>
		<a (click)="notification.actionConfig.actionCallback()" class="text-16-bold underline">
			<span [dcrHTMLKey]="notification.actionConfig.actionDcrKey">{{ notification.actionConfig.actionDcrValue }}</span>
		</a>
	</ng-container>
</div>
